
export const consentPropertyType = "site_consent";
export const cookieConsentPropertyType = "CookieConsent";

export const errorEventsName = {
  empty: "err_lnd_name_noname",
  too_short: "err_lnd_name_shortname",
  invalid_chars: "err_lnd_name_symbolname",
};
export const Questing1 = [
  "Serious relationship",
  "Casual chats",
  "Friendship",
  "Open to various connections",
]
export const joinReasons = {
  9: { label: "Serious relationship", event: "cl_lnd_first_ques_serious" },
  10: { label: "Casual chats", event: "cl_lnd_first_ques_casual" },
  11: { label: "Friendship", event: "cl_lnd_first_ques_friendship" },
  12: { label: "Open to various connections", event: "cl_lnd_first_ques_open" },
};
export const errorEventsBirthday = {
  N: "err_lnd_age_nodate",
  M: "err_lnd_age_onlymonth",
  D: "err_lnd_age_onlyday",
  Y: "err_lnd_age_onlyyear",
  MD: "err_lnd_age_onlydaymonth",
  DY: "err_lnd_age_onlydayyear",
  MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
  "Please enter your email address": "err_lnd_email_noemail",
  "Please enter a valid email address": "err_lnd_email_wrongemail",
};

export const errorEventsPassword = {
  empty: "err_lnd_password_nopassword",
  too_short: "err_lnd_password_shortpassword",
};

export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";

export const IS_VISIBLE_CUSTOM_AUTOCOMPLETE = false;

export const domains = [
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@aol.com",
  "@outlook.com",
  "@comcast.net",
  "@live.com",
  "@mail.com",
  "@msn.com",
  "@att.net",
  "@icloud.com",
];

export const landingId = "069d524ffe8359c08443b89fbc7550da";
